import axios from 'axios'
import { set } from 'vue'

// Initial state factory function
const getDefaultState = () => {
  return {
    warehouse: [],
    models: [],
    deviceStatusList: []
  }
}

export default {
  state: getDefaultState(),
  mutations: {
    SET_WAREHOUSES(state, payload) {
      set(state, 'warehouse', payload)
    },
    SET_MODELS(state, payload) {
      set(state, 'models', payload)
    },
    SET_STATUS_LIST(state, payload) {
      set(state, 'deviceStatusList', payload)
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    getGlobalLists({ dispatch }) {
      dispatch('getWarehousesList')
      dispatch('getModelsList')
      dispatch('getDeviceStatusList')
    },
    async getWarehousesList({ commit }) {
      const res = await axios('/warehouse/list')
      commit('SET_WAREHOUSES', res.data.content)
    },
    async getModelsList({ commit }) {
      const res = await axios('/device/model/list')
      commit('SET_MODELS', res.data.content)
    },
    async getDeviceStatusList({ commit }) {
      const res = await axios('/deviceStatus/list')
      commit('SET_STATUS_LIST', res.data.content)
    }
  }
}
